import React, { useContext, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import { dropdownConfigforModules } from "./DropdownConfig";

import { getCurrentlyRederedModule, UserDetailsContext } from "App";
import { getCurrentlyRederedSettingsSubModule } from "app/settings/base/SettingsPage";
import {
  getCurrentlyRenderedSubModule,
  setCurrentCustomerIdGlobal,
  setCustomerSwitching,
} from "../Root";

import Dropdown from "./Dropdown";

import { inventoryRouteMeta as inventoryRoutesList } from "app/inventory-new/base/inventoryRouteMeta";
import { manageDevicesRouteMeta as manageDevicesRoutesList } from "app/manage/base/manageDeviceRoutesMeta";
import { patchRouteMeta as patchRoutesList } from "app/patch/patchRoutesMeta";
import { alertsRouteMeta as alertsRoutesList } from "app/inventory-new/alerts/alertsRoutesMeta";
import { remoteRouteMeta as remoteRoutesList } from "app/remote/base/remoteRouteMeta";
import { reportsRouteMeta as reportsRoutesList } from "app/reports/base/reportsRoutesMeta";
import { enrollmentRouteMeta as enrollmentRoutesList } from "app/enrollment-new/base/enrollmentRoutesMeta";
import { ALL_CUSTOMER_ID } from "utils/mspConstants";

// 0 - no customerId change occurs but in ui alone All Customers will be set in disable
// 1 - all customer option selected disabled
// 2 - customer specific options and first cutomer will be selected if no customer ID
// 3 - both all customer and customer specific options and selected cutomer or all customer
// -1 - abrupt dropdown disable

const CustomerSwitch = ({ setMode, mode }) => {
  const location = useLocation();
  const userDetails = useContext(UserDetailsContext);
  const currentCustomerId = userDetails?.currentCustomerId;

  const functionForModule = {
    HOME: () => "HOME",
    HOME_CUSTOMER_SUMMARY: () => "HOME_CUSTOMER_SUMMARY",
    INVENTORY: () => getCurrentlyRenderedSubModule(inventoryRoutesList),
    INVENTORY_CUSTOMER_SUMMARY: () => "INVENTORY_CUSTOMER_SUMMARY",
    ENROLLMENT: () => getCurrentlyRenderedSubModule(enrollmentRoutesList),
    ALERTS: () => getCurrentlyRenderedSubModule(alertsRoutesList),
    REMOTE: () => getCurrentlyRenderedSubModule(remoteRoutesList),
    MANAGE: () => getCurrentlyRenderedSubModule(manageDevicesRoutesList),
    PATCH: () => getCurrentlyRenderedSubModule(patchRoutesList),
    PATCH_CUSTOMER_SUMMARY: () => "PATCH_CUSTOMER_SUMMARY",
    REPORTS: () => getCurrentlyRenderedSubModule(reportsRoutesList),
    SETTINGS: getCurrentlyRederedSettingsSubModule,
  };

  useEffect(() => {
    //used to force a customer dropdown mode in the code rather than auto chnaging of mode referring dropdown config
    const forcedMode = localStorage.getItem("forcedDropdownMode");
    if (forcedMode) 
    {
      setMode(Number(forcedMode));
      localStorage.removeItem("forcedDropdownMode");
      return;
    }

    //get the currently rendered module and sub module
    const module = getCurrentlyRederedModule();
    const subModule =functionForModule[module]?.() || "No function for the module " + module + " to find submodule";

    //get a mode for the the currently rendered submodule
    const newMode = dropdownConfigforModules[subModule] || 0;

    //laoding the variable if there is any customer change recorded for haulting the pre api calling
    let willCustomerChange = false;
    const forcedId = localStorage.getItem("forcedCustomerId");
    if (forcedId) 
      willCustomerChange = true;

    // mode 1 => force All Customers ---- customer id will change
    if (newMode === 1 && Number(currentCustomerId) !== ALL_CUSTOMER_ID)
      willCustomerChange = true;
    // mode 2 => force specific customer ---- customer id will change
    else if (newMode === 2 && Number(currentCustomerId) === ALL_CUSTOMER_ID)
      willCustomerChange = true;

    setCustomerSwitching(willCustomerChange);
    setMode(newMode);
  }, [location.pathname]);

  // if forcedCustomerId is seen in localstorage, set that id as currentCustomerId
  useEffect(() => {
    const forcedCustomerId = localStorage.getItem("forcedCustomerId");
    if (!forcedCustomerId) 
      return;

    localStorage.removeItem("forcedCustomerId"); //remove after obtaining it

    if (Number(userDetails.currentCustomerId) === Number(forcedCustomerId))
      return;

    userDetails.setUserDetails((prev) => ({
      ...prev,
      currentCustomerId: forcedCustomerId,
    }));
  }, [location.pathname]);

  //rendering the dropdonw based on the mode
  return <Dropdown mode={mode} />;
};

export default CustomerSwitch;
